import { ApiProject } from "@incendium/api";
import { Typography } from "@mui/material";
import ProjectCodeSnippet from "features/project/components/ProjectCodeSnippet";

interface IOnboardingGeneralProps {
  project: ApiProject;
}

function OnboardingGeneral({ project }: IOnboardingGeneralProps) {
  return (
    <div>
      <Typography variant="subtitle1" mb={1}>
        You can add the Incendium Pixel to your site manually or via Google Tag
        Manager (GTM).
      </Typography>
      <Typography variant="body1" mb={2}>
        Simply copy the below code and past it before the closing {"</head>"} on
        your website or in GTM
      </Typography>
      <ProjectCodeSnippet project={project} />
    </div>
  );
}

export default OnboardingGeneral;
